import { render } from "./schools-table.vue?vue&type=template&id=ac69ea8e"
import script from "./schools-table.js?vue&type=script&lang=js"
export * from "./schools-table.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__